module.exports = __webpack_public_path__ + "media/images/flags/1x1/mdv-2fa83f4fa959e2c756a6e87fd5f9fcca.svg";